import { SvgIcon, type SvgIconProps } from '@mui/material';
import type { ElementType, FunctionComponent } from 'react';

import {
  isScmConnectionAAzureDevOpsConnection,
  isScmConnectionABitbucketCloudConnection,
  isScmConnectionABitbucketConnection,
  isScmConnectionAGithubConnection,
  isScmConnectionAGitLabConnection
} from '../../../__generated__/apollo-hooks';
import {
  AzureDevOpsIcon,
  BitBucketIcon,
  GitHubIcon,
  GitLabIcon,
  RepositoryIcon
} from '../../../icons/icons';

type ScmIconProps = {
  configuration?: { __typename?: string };
  SvgIconProps?: SvgIconProps;
};

function getScmIcon(configuration?: { __typename?: string }): ElementType {
  if (isScmConnectionAGithubConnection(configuration)) {
    return GitHubIcon;
  }

  if (isScmConnectionAGitLabConnection(configuration)) {
    return GitLabIcon;
  }

  if (
    isScmConnectionABitbucketConnection(configuration) ||
    isScmConnectionABitbucketCloudConnection(configuration)
  ) {
    return BitBucketIcon;
  }

  if (isScmConnectionAAzureDevOpsConnection(configuration)) {
    return AzureDevOpsIcon;
  }

  return RepositoryIcon;
}

export const getScmConnectionDisplayName = (configuration?: {
  __typename?: string;
}): string | undefined => {
  if (isScmConnectionAGithubConnection(configuration)) {
    return 'GitHub';
  }
  if (isScmConnectionAGitLabConnection(configuration)) {
    return 'GitLab';
  }
  if (
    isScmConnectionABitbucketConnection(configuration) ||
    isScmConnectionABitbucketCloudConnection(configuration)
  ) {
    return 'Bitbucket';
  }
  if (isScmConnectionAAzureDevOpsConnection(configuration)) {
    return 'Azure DevOps';
  }
  return undefined;
};

/**
 * Displays an SCM provider icon based on the connection type.
 */
export const ScmConnectionIcon: FunctionComponent<ScmIconProps> = ({
  configuration,
  SvgIconProps = {}
}) => {
  return (
    <SvgIcon
      component={getScmIcon(configuration)}
      inheritViewBox
      {...SvgIconProps}
      sx={{
        ...SvgIconProps.sx,
        color: 'text.primary',
        fill: 'none' // MUI's `component` variant defaults fill to currentColor
      }}
    />
  );
};
